import { Component } from '@angular/core';

/** Coquille hôte : barre de titre + ajout/modification fournisseur bibliothèque. */
@Component({
  selector: 'app-add-fournisseur-shell',
  template: '<app-title-section></app-title-section><router-outlet></router-outlet>'
})
export class AddFournisseurShellComponent {}
